// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"a75472d6","72":"a75472d6","154":"a75472d6","580":"0afbd8fc","683":"a75472d6"}[chunkId] + ".chunk.css";
};